import script from "./Subnav.vue?vue&type=script&lang=ts&setup=true"
export * from "./Subnav.vue?vue&type=script&lang=ts&setup=true"

import "./Subnav.vue?vue&type=style&index=0&id=88745d22&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88745d22"]])

export default __exports__